import { render, staticRenderFns } from "./CompanyLicenceItem.vue?vue&type=template&id=06bd93e7&scoped=true"
import script from "./CompanyLicenceItem.vue?vue&type=script&lang=js"
export * from "./CompanyLicenceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd93e7",
  null
  
)

export default component.exports